import React from 'react'
import styled, { css } from 'styled-components'

import Button from '../Button'

const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 1px 0 rgba(10, 22, 70, 0.1),
    0 0 1px 0 rgba(10, 22, 70, 0.06);
  border-radius: 8px;
  display: flex;
  margin: 0 0 24px;
  padding: 28px;
  position: relative;
  top: -100px;
  transition: box-shadow 0.3s ease;

  a {
    margin-left: 24px;

    ${({ green }) =>
      green &&
      css`
        background-color: #398361;
        border: 1px solid #398361;

        :hover {
          background-color: #337557;
          border: 1px solid #337557;
        }
      `}
  }

  :hover {
    box-shadow: 0 1px 1px 0 rgba(10, 22, 70, 0.1),
      0 0 1px 0 rgba(10, 22, 70, 0.06), 0 28px 70px -7px rgba(5, 15, 54, 0.16);
  }

  ${({ theme }) => theme.media.desktop} {
    margin: 0 24px 0 0;
    max-width: 500px;
    padding: 32px;

    :last-of-type {
      margin: 0;
    }
  }
`

const StyledContent = styled.div`
  flex-basis: 80%;
`

const StyledHeader = styled.h3`
  color: #0a1f44;
  font-size: 20px;
  line-height: 1.6;
  margin: 0 0 8px;
  padding-left: 24px;
`

const StyledText = styled.p`
  color: #506174;
  font-size: 14px;
  line-height: 1.71;
  margin: 0 0 16px;
  padding-left: 24px;
`

const StyledIcon = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 64px;
  height: 64px;
  justify-content: center;
  position: relative;
  width: 64px;

  :before {
    background-color: ${({ green }) => (green ? '#398361' : '#c02428')};
    border-radius: 50%;
    content: '';
    height: 100%;
    left: 0;
    opacity: 0.08;
    position: absolute;
    top: 0;
    width: 100%;
  }

  ${({ theme }) => theme.media.desktop} {
    flex-basis: 64px;
  }
`

const ContactBox = ({ cmsData }) => {
  return (
    <StyledWrapper green={cmsData.buttonColor}>
      <StyledIcon green={cmsData.buttonColor}>
        <img alt={cmsData.header} loading="lazy" src={cmsData.icon.fields.file.url} />
      </StyledIcon>
      <StyledContent>
        <StyledHeader>{cmsData.header}</StyledHeader>
        <StyledText>{cmsData.text}</StyledText>
        <Button
          to={cmsData.button.fields.buttonLink}
          external={cmsData.button.fields.external}
          primary
        >
          {cmsData.button.fields.buttonText}
        </Button>
      </StyledContent>
    </StyledWrapper>
  )
}

export default ContactBox
